/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface RepresentantSearch
 */
export interface RepresentantSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof RepresentantSearch
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof RepresentantSearch
     */
    prenom?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof RepresentantSearch
     */
    nomInstitution?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof RepresentantSearch
     */
    nomApprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof RepresentantSearch
     */
    prenomApprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepresentantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RepresentantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RepresentantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RepresentantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RepresentantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RepresentantSearch interface.
 */
export function instanceOfRepresentantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RepresentantSearchFromJSON(json: any): RepresentantSearch {
    return RepresentantSearchFromJSONTyped(json, false);
}

export function RepresentantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepresentantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : UnaccentTextSearchFromJSON(json['prenom']),
        'nomInstitution': !exists(json, 'nomInstitution') ? undefined : UnaccentTextSearchFromJSON(json['nomInstitution']),
        'nomApprenant': !exists(json, 'nomApprenant') ? undefined : UnaccentTextSearchFromJSON(json['nomApprenant']),
        'prenomApprenant': !exists(json, 'prenomApprenant') ? undefined : UnaccentTextSearchFromJSON(json['prenomApprenant']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RepresentantSearchToJSON(value?: RepresentantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': UnaccentTextSearchToJSON(value.nom),
        'prenom': UnaccentTextSearchToJSON(value.prenom),
        'nomInstitution': UnaccentTextSearchToJSON(value.nomInstitution),
        'nomApprenant': UnaccentTextSearchToJSON(value.nomApprenant),
        'prenomApprenant': UnaccentTextSearchToJSON(value.prenomApprenant),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

